import { render } from "./box-content.vue?vue&type=template&id=06e0eb8b"
import script from "./box-content.vue?vue&type=script&lang=js"
export * from "./box-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__